export default "__VITE_ASSET__DbHoMwpx__"